import { withInstall } from '@tw-element/utils'
import Row from './src/row'

export const TwRow = withInstall(Row)
export default TwRow

export * from './src/row'
